<template>
    <div class="reason">
        <el-dialog :title="title" width="30%" :visible.sync="dialogChangeVisible">
            <div class="product_box">
                <product-box :row="row" :tabName="tabName"></product-box>
            </div>
            <div class="user_info_box mt-10">
                <user-info-box  :row="row" :tabName="tabName"></user-info-box>
            </div>
            <div class="mt-20 pl-10 pr-10 yx-color-text-primary fz-14">
                <p>
                    {{ state ==='1' ? row.refuse_content : row.refuse_delivery_content }}
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogChangeVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
export default {
    name: 'reason',
    components: {
        productBox,
        userInfoBox,
        tipsBox
    },
    data() {
        return {
            dialogChangeVisible: false,
            row: {},
            tabName: '',
            state: '',
            title: ''
        }
    },
    methods: {
        initReasonFun(row, state, tabName) {
            this.state = state
            this.row = row
            this.tabName = tabName
            if(state === '1') {
                this.title = '拒绝带货原因'
            }else {
                this.title = '拒绝发货原因'
            }
            this.dialogChangeVisible = true
        }
    }
}
</script>
<style lang="less" scoped>

</style>